import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';

ReactDOM.render(
  <React.StrictMode>
    <div style={{ marginTop: '5px', marginBottom: '50px' }} className="container">
      <main className="col-lg-10 mx-auto p-3 py-md-5">
        <App />
      </main>
    </div>
  </React.StrictMode>,
  document.getElementById('root')
);
